import classNames from "classnames";
import { FC } from "react";

import Modal from "components/Modal";
import ModalRemoveAssetContent from "./Content";

import styles from "./style.module.scss";

type PropTypes = {
  isVisible: boolean;
  className?: string;
  id?: number;
  name?: string;
};

const WidgetModalRemoveAsset: FC<PropTypes> = ({ isVisible, className, id, name }) => {
  return (
    <Modal title="Delete asset" isClose isCloseBg isVisible={isVisible} className={classNames(styles.modal, className)}>
      <ModalRemoveAssetContent id={id} name={name} />
    </Modal>
  );
};

export default WidgetModalRemoveAsset;
